import React, { memo } from 'react';

import * as S from './style';

interface IProps {
  /** items */
  items?: React.ReactNode;
}

const TextRankList = ({ items }: IProps) => (
  <S.TextRankList>{items}</S.TextRankList>
);

export default memo(TextRankList);
